import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merges class names so a caller's utility can override a component default. */
export function cn(...klasser: ClassValue[]): string {
  return twMerge(clsx(klasser));
}
